import Vue from 'vue'
import Vuex from 'vuex'
import LookupService from "../services/LookupService";
import UnitService from "../services/UnitService";
import AvailabilityService from "../services/AvailabilityService";
import RateService from "../services/RateService";
import AmenitiesService from "../services/AmenitiesService";
import moment from "moment";


Vue.use(Vuex)

export const store = new Vuex.Store({
    // from Vue component
    actions: {
        // get Categories
        getCategories: ({ commit }, categoriesParams) => {
            LookupService.getCategories(categoriesParams.auth_token)
                .then(response => {
                    // console.log(response.data)
                    commit('SET_CATEGORIES', response.data)
                })
        },
        getUnits: ({ commit }, unitParams) => {
            UnitService.getUnits(unitParams.auth_token)
                .then(response => {
                    // console.log(response.data)
                    commit('SET_UNITS', response.data)
                })
        },
        getAvailability: ({ commit }, availabilityParams) => {
            AvailabilityService.getavailabilities(availabilityParams.auth_token)
                .then(response => {
                    // console.log(response.data)
                    commit('SET_AVAILABILITY', response.data)
                })
        },
        getRates: ({ commit }, ratesParams) => {
            RateService.getRates(ratesParams.auth_token)
                .then(response => {
                    // console.log(response.data)
                    commit('SET_RATES', response.data)
                })
        },
        getAmenities: ({ commit }, amenitiesParams) => {
            AmenitiesService.getAmenities(amenitiesParams.auth_token)
                .then(response => {
                    // console.log(response.data)
                    commit('SET_AMENITIES', response.data)
                })
        },
    },
    mutations: {
        loadingStatus(state, newLoadingStatus) {
            state.loadingStatus = newLoadingStatus
        },
        'SET_CATEGORIES'(state, data) {
            state.categories = data
        },
        'SET_UNITS'(state, data) {
            state.units = data
        },
        'SET_AVAILABILITY'(state, data) {
            state.availability = data
        },
        'SET_RATES'(state, data) {
            state.rates = data
        },
        'SET_AMENITIES'(state, data) {
            state.amenities = data
        }
    },
    state: {
        categories: [],
        units: [],
        availability: [],
        rates: [],
        amenities: [],
        loadingStatus: false
    },
    getters: {
        categories: (state) => {
            return state.categories
        },
        units: (state) => (category) => {
            return state.units
                .filter(units => (units.category_id == category && category > 0) || category == 0)
        },
        availability: (state) => (formattedFrom, formattedTo, category) => {
            return state.availability
                .filter(availability => moment(availability.day).format('YYYY-MM-DD') >= formattedFrom)
                .filter(availability => moment(availability.day).format('YYYY-MM-DD') <= formattedTo)
                .filter(availability => (availability.category_id == category && category > 0) || category == 0)
        },
        rates: (state) => (ratesFormattedFrom, formattedTo) => {
            return state.rates
                // .filter(rates => rates.category_id == categorySelected)
                .filter(rates => moment(rates.day).format('YYYY-MM-DD') >= ratesFormattedFrom)
                .filter(rates => moment(rates.day2).format('YYYY-MM-DD') <= formattedTo)
        },
        amenitySearch: (state) => {
            return state.amenities
        },
        loadingStatus (state) {
            return state.loadingStatus
        }
    }
})
